var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotSupported(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.998,
    height: 19.998,
    viewBox: "0 0 19.998 19.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "not_supported",
    "data-name": "not supported",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M19.836,18.748,17.3,16.214l2.533-2.533a.768.768,0,0,0-1.086-1.086l-2.533,2.533-2.533-2.533A.768.768,0,0,0,12.6,13.681l2.533,2.533L12.6,18.748a.743.743,0,0,0,0,1.086.763.763,0,0,0,1.086,0L16.216,17.3l2.533,2.533a.772.772,0,0,0,1.086,0A.763.763,0,0,0,19.836,18.748Z",
    transform: "translate(-2.842 -2.84)",
    fill: "#e42c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3437",
    "data-name": "Path 3437",
    d: "M13.374,4.721a8.65,8.65,0,1,1-6.12,2.533,8.6,8.6,0,0,1,6.12-2.533m0-1.346a10,10,0,1,0,10,10,10,10,0,0,0-10-10Z",
    fill: "#e42c2c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSupported);
export default __webpack_public_path__ + "static/media/not-supported.d8abeb8eb72048f49366b796ccf80466.svg";
export { ForwardRef as ReactComponent };